import React from 'react'
import ModuleSpoiler from '../../../ui/ModuleSpoiler/ModuleSpoiler'
import './LandingSeoSection.sass'

/**
 * Shared collapse wrapper for SEO blocks (closed by default).
 * Pass bodyClassName for LandingSeoSection / ProductSeoSection variants.
 */
function SeoSectionShell({
  title,
  children,
  bodyClassName = 'LandingSeoSection LandingSeoSection_inSpoiler',
}) {
  return (
    <ModuleSpoiler title={title} defaultExpanded={false}>
      <div className={bodyClassName}>{children}</div>
    </ModuleSpoiler>
  )
}

export default SeoSectionShell
